export enum Scheme {
    Ftp = 'ftp://',
    Http = 'http://',
    Https = 'https://',
    MailTo = 'mailto:',
    Sms = 'sms:',
    Tel = 'tel:',
    GoogleReview = 'google-review:',
}
